"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AltiumNamingPinNamingRule = void 0;
const sigma_engine_shared_1 = require("@cadstrom/sigma-engine-shared");
const AltiumNetNamingRule_1 = require("./AltiumNetNamingRule");
class AltiumNamingPinNamingRule extends AltiumNetNamingRule_1.AltiumNetNamingRule {
    apply(group, _hierarchy) {
        const namingPinNames = [];
        for (const [_instance, nets] of group.getNets()) {
            for (const net of nets) {
                for (const conn of net.connections) {
                    if (conn.connection.appliesNetName) {
                        namingPinNames.push(conn.connection.appliesNetName.label);
                    }
                }
            }
        }
        if (namingPinNames.length === 0) {
            return undefined;
        }
        namingPinNames.sort((a, b) => sigma_engine_shared_1.Utils.naturalStringSort(a, b));
        return this.dereferenceLabelName(namingPinNames[0]);
    }
}
exports.AltiumNamingPinNamingRule = AltiumNamingPinNamingRule;
//# sourceMappingURL=AltiumNamingPinNamingRule.js.map